<template>
  <v-data-table :headers="headers" :items="surgeryTechniques" sort-by="name">
    <template v-slot:top>
      <v-toolbar flat>
        <v-dialog v-model="dialog" max-width="500px" @click:outside="close">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="light-blue" dark v-bind="attrs" v-on="on">
              Nova técnica
            </v-btn>
          </template>

          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container fluid>
                <v-row dense>
                  <v-col>
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      v-model="editedItem.name"
                      label="Nome"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>

              <v-btn color="blue darken-1" text @click="save">
                Salvar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <authorization
        permissionKey="configuration_facilitator_hma"
        can="save"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small class="mr-2" @click="editItem(item)">
          eva-edit-outline
        </v-icon>
      </authorization>

      <authorization
        permissionKey="configuration_facilitator_hma"
        can="delete"
        v-slot:default="{ authorization }"
      >
        <v-icon v-if="authorization" small @click="deleteItem(item)">
          eva-trash-outline
        </v-icon>
      </authorization>
    </template>

    <template v-slot:no-data>
      <v-alert color="orange" outlined text type="info">
        Não há técnicas cadastradas
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
  export default {
    name: "TechniquesList",
    props: {
      surgeryType: Object,
    },
    data() {
      return {
        dialog: null,
        editedItem: {},
        defaultItem: {},
        editedIndex: -1,
        headers: [
          { text: "Name", value: "name" },
          { text: "Ações", value: "actions", sortable: false, align: "end" },
        ],
        surgeryTechniques: [],
      };
    },
    mounted() {
      this.surgeryTechniques = [];
    },
    watch: {
      surgeryType() {
        this.surgeryTechniques = [];
      },
    },
    apollo: {
      surgeryTechniques: {
        query: require("@/graphql/surgery_type/surgery_techniques.gql"),
        variables() {
          return {
            surgeryTypeId: this.surgeryType.id,
          };
        },
        pollInterval: 20000,
        skip() {
          return !this.surgeryType?.id;
        },
      },
    },
    computed: {
      formTitle() {
        return this.editedIndex === -1 ? "Nova técnica" : "Editar técnica";
      },
    },
    methods: {
      editItem(item) {
        this.editedIndex = this.surgeryTechniques.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.dialog = true;
      },
      deleteItem(item) {
        if (confirm("Você realmente deseja deletar esse técnica?")) {
          this.apolloMutate({
            mutation: require("@/graphql/surgery_type/delete_surgery_technique.gql"),
            variables: {
              surgeryTechniqueId: item.id,
            },
          }).then(() => {
            this.refreshList();
            this.$store.dispatch("createNotification", {
              message: "Técnica deletada com sucesso.",
              type: "success",
            });
          });
        }
      },
      close() {
        this.dialog = false;
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        });
      },
      save() {
        this.apolloMutate({
          mutation: require("@/graphql/surgery_type/save_surgery_technique.gql"),
          variables: {
            surgeryTechniqueId: this.lodash.get(this.editedItem, "id", ""),
            surgeryTypeId: this.surgeryType.id,
            name: this.editedItem.name,
          },
        }).then(() => {
          this.refreshList();

          this.$store.dispatch("createNotification", {
            message: "Cadastro salvo com sucesso.",
            type: "success",
          });
        });

        this.close();
      },
      refreshList() {
        return this.$apollo.queries.surgeryTechniques.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
